import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomePage.css";

export default function HomePage() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    mobileFirst: true, // Breakpoints sind jetzt MIN-width
    slidesToShow: 1, // Default: Mobile
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      { breakpoint: 641, settings: { slidesToShow: 2 } }, // ≥641px → 2
      { breakpoint: 1025, settings: { slidesToShow: 3 } }, // ≥1025px → 3
    ],
  };

  return (
    <div className="page-container">
      <main className="home-main">
        <h1>
          Willkommen in der Schwimm- und Tauchgemeinschaft DiverDuck Berlin
          e.V.!
        </h1>
        <p className="home-intro">
          Unser Tauchverein bietet einen Einblick in die vielfältige und
          aufregende Welt des Tauchens. Wir sind stolz darauf, Menschen jeden
          Alters und Erfahrungsstands zu unterstützen und in die Welt des
          Tauchsports einzuführen. Egal ob Flossenschwimm-Anfänger oder
          erfahrener Taucher, bei uns findest Du die richtige Umgebung, um Deine
          Leidenschaft für das Tauchen zu entdecken und gemeinsame Erfahrungen
          mit anderen zu teilen.
        </p>

        <div className="slider-wrap">
          <Slider {...settings}>
            <div>
              <img
                className="slider-img"
                src="/images/bild1.png"
                alt="Bild 1"
              />
            </div>
            <div>
              <img
                className="slider-img"
                src="/images/bild2.png"
                alt="Bild 2"
              />
            </div>
            <div>
              <img
                className="slider-img"
                src="/images/bild3.png"
                alt="Bild 3"
              />
            </div>
            <div>
              <img
                className="slider-img"
                src="/images/bild4.png"
                alt="Bild 4"
              />
            </div>
          </Slider>
        </div>
      </main>
    </div>
  );
}
